/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
import i18n, { TFunction } from 'i18next';
import I18nextBrowserLanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';
// import ICU from 'i18next-icu';
import { initReactI18next } from 'react-i18next';
import { APP_INFO } from '../config';
import NameSpaces from './NameSpaces';
import { CURRENT_LOCALE_LOCAL_STORE_KEY, languages, languagesArray } from './values';

enum IEQueryParams {
  LANGUAGE_VALUE = 'LanguageValue',
}

const queryParams = new URLSearchParams(window.location.search);
const languageValue = queryParams.get(IEQueryParams.LANGUAGE_VALUE);

if (languageValue) {
  window.localStorage.setItem(CURRENT_LOCALE_LOCAL_STORE_KEY, languageValue);
}

const currentLocale = window.localStorage.getItem(CURRENT_LOCALE_LOCAL_STORE_KEY) || i18n.language || languages.en.id;


// .use(ICU)
i18n
  .use(Backend)
  .use(initReactI18next) // passes i18n down to react-i18next
  .use(I18nextBrowserLanguageDetector)
  .init({
    supportedLngs: [languages.en.id, languages.es.id, languages.pt.id],
    // resources,
    backend: {
      // for all available options read the backend's repository readme file
      loadPath: `/locales/{{lng}}/{{ns}}.json?v=${APP_INFO.version}`,
    },
    // lng: currentLocale,
    ns: NameSpaces,
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
  });

const setLang = (lang: string): Promise<TFunction<'translation', undefined>> => {
  window.localStorage.setItem(CURRENT_LOCALE_LOCAL_STORE_KEY, lang);
  return i18n.changeLanguage(lang as string);
};

export default i18n;

export { languages, languagesArray, setLang, currentLocale };
